import React, { useContext } from 'react';
import { Text } from 'components/typography';
import classNames from 'classnames';
import { LaundryBrikkModalContext } from 'components/brikks/home/LaundryService/components/LaundryBrikkContent/index';
import styles from './styles.module.scss';

export const ResourceSelectionSection = ({ laundryResources }) => {
  const { selectedResource, setSelectedResource } = useContext(
    LaundryBrikkModalContext,
  );

  return (
    <div className={styles.resourceSelection}>
      {laundryResources.map((resource) => (
        <div
          key={resource.id}
          className={classNames(
            styles.resourceCard,
            selectedResource?.id === resource.id && styles.active,
          )}
          onClick={() => {
            if (selectedResource?.id === resource.id) setSelectedResource();
            else setSelectedResource(resource);
          }}
        >
          <div
            className={classNames(
              styles.icon,
              selectedResource?.id === resource.id && styles.activeIcon,
            )}
          >
            {resource?.icon}
          </div>
          <Text
            size={14}
            center
            breakAll
            className={
              selectedResource?.id === resource.id && styles.activeText
            }
          >
            {resource?.name}
          </Text>
        </div>
      ))}
    </div>
  );
};
